module.exports = __webpack_public_path__ + "img/bus_green.d32264a8.svg";